import React from 'react';
import PropTypes from 'prop-types';
import { formatDateUTC } from 'utils/Formatters';
import classNames from 'classnames';
import ASQSectionResults from './ASQSectionResults';
import ASQ_SE2Logo from '/assets/images/asq_se2-logo.svg';
import ASQ_3Logo from '/assets/images/asq_3-logo.svg';

export default class ASQSimpleSurveysRow extends React.PureComponent {
    static propTypes = {
      auth: PropTypes.object.isRequired,
      location:  PropTypes.object.isRequired,
      playerId:  PropTypes.number.isRequired,
      questionnaire:  PropTypes.object.isRequired,
      playerIdx: PropTypes.number.isRequired,
      onASQLink: PropTypes.func.isRequired,
    }

    static getLogo(type) {
      if (type === 'asq_3') {
        return <img src={ASQ_3Logo} width="120" height="30" alt="asq3 report"/>
      } else {
        return <img src={ASQ_SE2Logo} width="120" height="30" alt="asq2 report"/>
      }
    }

    onClick = (e) => {
      e.stopPropagation();
      const { playerId, questionnaire, onASQLink, location } = this.props;
      onASQLink(playerId, questionnaire.id, location);
    }

    render() {
      const { questionnaire, playerIdx } = this.props;
      const s = questionnaire;
      const clsRow = classNames('o-rtable__row u-pointer', {'cs-bg--sp-hover': playerIdx % 2 === 0});
      return (
        <div className={clsRow} onClick={this.onClick}>
          <div className={`o-rtable__cell cs-txt--${s.type}`}>
            {s.name} {s.age}
          </div>
          { s ?
            <div className='o-rtable__cell o-rtable__cell--date'>
              {formatDateUTC(s.dateFinished)}<br/>
            </div> :
            <div className='o-rtable__cell o-rtable__cell--date'></div> }
          <div className='o-rtable__cell'>
            <ASQSectionResults survey={s} />
          </div>
        </div>
      );
    }
}
